import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { LanguageContext, getTranslation } from '../LanguageContext';
import { FaImages, FaArrowLeft, FaSpinner, FaCamera, FaFolderOpen } from 'react-icons/fa';
import './PhotosPage.css';

const photosTranslations = {
  en: {
    title: "Photos",
    subtitle: "Browse our photo gallery",
    loading: "Loading photos...",
    noPhotos: "No photo albums available yet",
    photos: "photos",
    viewAlbum: "View Album",
    back: "Back",
    allAlbums: "All Photo Albums"
  },
  fr: {
    title: "Photos",
    subtitle: "Parcourez notre galerie photos",
    loading: "Chargement des photos...",
    noPhotos: "Aucun album photo disponible pour le moment",
    photos: "photos",
    viewAlbum: "Voir l'album",
    back: "Retour",
    allAlbums: "Tous les albums photos"
  },
  ar: {
    title: "الصور",
    subtitle: "تصفح معرض الصور الخاص بنا",
    loading: "جاري تحميل الصور...",
    noPhotos: "لا توجد ألبومات صور متاحة حالياً",
    photos: "صور",
    viewAlbum: "عرض الألبوم",
    back: "العودة",
    allAlbums: "جميع ألبومات الصور"
  }
};

const PhotosPage = () => {
  const [imageAlbums, setImageAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const { language } = useContext(LanguageContext);
  const translate = (key) => getTranslation(photosTranslations, language, key);
  const isRTL = language === 'ar';

  useEffect(() => {
    const fetchImages = async () => {
      try {
        setLoading(true);
        const res = await axios.get('http://localhost:4444/images');
        setImageAlbums(res.data.data || []);
      } catch (error) {
        console.error('Error fetching image albums:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  if (loading) {
    return (
      <div className="photos-page">
        <div className="photos-page-loading">
          <FaSpinner className="spin" />
          <p>{translate('loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`photos-page ${isRTL ? 'rtl' : ''}`}>
      <div className="photos-page-hero">
        <div className="photos-page-hero-overlay"></div>
        <div className="photos-page-hero-content">
          <div className="photos-page-hero-nav">
            <Link to="/" className="photos-page-back-btn">
              <FaArrowLeft />
              <span>{translate('back')}</span>
            </Link>
          </div>
          <div className="photos-page-hero-icon">
            <FaCamera />
          </div>
          <h1>{translate('title')}</h1>
          <p>{translate('subtitle')}</p>
        </div>
      </div>

      <div className="photos-page-content">
        <div className="photos-page-section-header">
          <h2>
            <FaFolderOpen />
            {translate('allAlbums')}
          </h2>
          <span className="photos-page-count">{imageAlbums.length}</span>
        </div>

        {imageAlbums.length === 0 ? (
          <div className="photos-page-empty">
            <FaImages className="empty-icon" />
            <p>{translate('noPhotos')}</p>
          </div>
        ) : (
          <div className="photos-page-grid">
            {imageAlbums.map((album) => (
              <Link to={`/images/${album._id}`} key={album._id} className="photos-page-card">
                <div className="photos-page-card-image">
                  {album.URLImages && album.URLImages.length > 0 ? (
                    <>
                      <img src={album.URLImages[0]} alt={album.title} loading="lazy" />
                      {album.URLImages.length > 1 && (
                        <div className="photos-page-card-mosaic">
                          {album.URLImages.slice(1, 3).map((img, i) => (
                            <div key={i} className="mosaic-thumb">
                              <img src={img} alt="" loading="lazy" />
                            </div>
                          ))}
                          {album.URLImages.length > 3 && (
                            <div className="mosaic-thumb mosaic-more">
                              <span>+{album.URLImages.length - 3}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="photos-page-card-placeholder">
                      <FaImages />
                    </div>
                  )}
                  <div className="photos-page-card-overlay">
                    <span className="photos-page-view-btn">{translate('viewAlbum')}</span>
                  </div>
                  <div className="photos-page-card-badge">
                    <FaImages />
                    <span>{album.URLImages?.length || 0} {translate('photos')}</span>
                  </div>
                </div>
                <div className="photos-page-card-body">
                  <h3>{album.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotosPage;
